export default "__VITE_ASSET__DCb_rdwt__"